export default {"src":"/_next/static/media/defi-k-line.5bdf4ee6.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};